import { useAssetVizInternal } from '@asset-viz/AssetVizInternalProvider'
import React from 'react'
import { GeckoMarkupPrimitive } from 'types'

/**
 * Hook to return the xyz path of the primitive that is being hovered or selected.
 * @param primitives Primitives to check (should exist on the same markup layer)
 * @param indexes    Index array for primitive xyz paths
 * @param xyzs       xyz line segment paths for all primitives
 * @returns
 */
export const useFindSelectedPrimitiveXyzs = (
  primitives: readonly GeckoMarkupPrimitive[],
  indexes: readonly number[] | undefined,
  xyzs: readonly number[] | undefined
): number[] => {
  const { selection, draftSelection } = useAssetVizInternal()
  return React.useMemo(() => {
    if (!xyzs || !indexes) return []
    for (let i = 0; i < primitives.length; i++) {
      const primitive = primitives[i]
      const isEditingThisPrimitive =
        selection instanceof GeckoMarkupPrimitive &&
        selection.id === primitive.id
      const isHoveringThisPrimitive =
        draftSelection instanceof GeckoMarkupPrimitive &&
        draftSelection.id === primitive.id
      if (isEditingThisPrimitive || isHoveringThisPrimitive) {
        return xyzs.slice(i === 0 ? 0 : indexes[i - 1] * 6, indexes[i] * 6)
      }
    }
    return []
  }, [primitives, indexes, xyzs, selection, draftSelection])
}
